import React from "react";
import { FormattedMessage } from "react-intl";
import { Box, Grid, GridItem, Stack, Switch, Text } from "@chakra-ui/react";
import { WalletIcon } from "components/Logos";
import { FormattedMoney } from "components/FormattedMoney";

const Wallet = ({ wallets, onClick, isSelected, onSelect, ...props }) => {
  const handleOnSelect = () => {
    onSelect(wallets);
  };

  const totalWalletBalance = wallets.reduce(
    (amount, wallet) => amount + wallet.provider_data.balance,
    0
  );

  return (
    <Grid
      pt="1"
      pl="5"
      pr="5"
      borderWidth="1px"
      borderRadius="4px"
      templateRows="repeat(5, 1fr)"
      alignItems="center"
      bgColor={isSelected ? "lightBackground" : "background"}
      borderColor={isSelected && "integrator.300"}
      boxShadow="base"
      {...props}
    >
      <GridItem gridRow="2/5">
        <Grid
          templateColumns="9fr 8fr"
          gridGap="2"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack spacing="2">
            <Box>
              <WalletIcon />
            </Box>
            <Text fontSize="xs">
              <FormattedMessage defaultMessage="Use your wallet balance" description="label" />
            </Text>
          </Stack>
          <Stack spacing="2" textAlign="right">
            <Box>
              <Switch
                isChecked={isSelected}
                onChange={handleOnSelect}
                data-testid="wallet-toggle"
              />
            </Box>
            <FormattedMoney fontSize="lg" value={totalWalletBalance} currency={"USD"} />
          </Stack>
        </Grid>
      </GridItem>
      <Box />
    </Grid>
  );
};

export default Wallet;
